//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { HopperOctopusApiClient } from "../hopperOctopusApiClient";
import { HopperOctopusConfiguration } from "../hopperOctopusConfiguration";

export const OctopusApiUrl = new InjectionToken<string>('OctopusApiUrl');

export interface IOctopusClient {
  /**
   * Lista as lojas disponíveis
   * @param name (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubStoreListEndpoint(name?: string | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<StoreListResponse>;
  /**
   * Personaliza o modelo de uma action
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppActionCreateOrUpdateEndpoint(orgAppId: string, actionId: string, createOrUpdateOrgAppActionRequest: CreateOrUpdateOrgAppActionRequest, accept_language?: string | null | undefined): Observable<OrgAppActionResponse>;
  /**
   * Apaga as configurações de uma action
   * @param accept_language (optional)
   * @return No Content
   */
  hubOrgAppActionDeleteEndpoint(orgAppId: string, actionId: string, accept_language?: string | null | undefined): Observable<void>;
  /**
   * Pega as configurações de uma action
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppActionGetEndpoint(orgAppId: string, actionId: string, accept_language?: string | null | undefined): Observable<OrgAppActionResponse>;
  /**
   * Lista as actions de um aplicativo instalado
   * @param categoryId (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppActionListEndpoint(orgAppId: string, categoryId?: number | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<OrgAppActionListResponse>;
  /**
   * Instala um aplicativo
   * @param accept_language (optional)
   * @return Created
   */
  hubOrgAppCreateEndpoint(createOrgAppRequest: CreateOrgAppRequest, accept_language?: string | null | undefined): Observable<void>;
  /**
   * Lista os aplicativos instalados
   * @param name (optional)
   * @param categoryId (optional)
   * @param status (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppListEndpoint(name?: string | null | undefined, categoryId?: number | null | undefined, status?: StatusType | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<OrgAppListResponse>;
  /**
   * Desinstala um aplicativo
   * @param accept_language (optional)
   * @return No Content
   */
  hubOrgAppDeleteEndpoint(id: string, accept_language?: string | null | undefined): Observable<void>;
  /**
   * Pega um aplicativo instalado
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppGetEndpoint(id: string, accept_language?: string | null | undefined): Observable<OrgAppResponse>;
  /**
   * Atualiza um aplicativo
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppUpdateEndpoint(id: string, updateOrgAppRequest: UpdateOrgAppRequest, accept_language?: string | null | undefined): Observable<OrgAppResponse>;
  /**
   * Cria uma organização
   * @param accept_language (optional)
   * @return Success
   */
  hubOrganizationCreateEndpoint(createOrganizationRequest: CreateOrganizationRequest, accept_language?: string | null | undefined): Observable<OrganizationResponse>;
  /**
   * Pega a organização autal
   * @param accept_language (optional)
   * @return Success
   */
  hubOrganizationGetEndpoint(accept_language?: string | null | undefined): Observable<OrganizationResponse>;
  /**
   * Atualiza a organização atual
   * @param accept_language (optional)
   * @return Success
   */
  hubOrganizationUpdateEndpoint(updateOrganizationRequest: UpdateOrganizationRequest, accept_language?: string | null | undefined): Observable<OrganizationResponse>;
  /**
   * Lista todos os aplicativos disponíveis
   * @param name (optional)
   * @param categoryId (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubApplicationListEndpoint(name?: string | null | undefined, categoryId?: number | null | undefined, accept_language?: string | null | undefined): Observable<ApplicationListResponse>;
  /**
   * Lista todas as actions instaladas
   * @param applicationId (optional)
   * @param categoryId (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubActionListEndpoint(applicationId?: string | null | undefined, categoryId?: number | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<ActionListResponse>;
  /**
   * @param accept_language (optional)
   * @return Success
   */
  actionsProductsGetFiltersEndpoint(getProductFilterDataRequest: GetProductFilterDataRequest, accept_language?: string | null | undefined): Observable<GetProductFilterDataResponse>;
  /**
   * @param accept_language (optional)
   * @return Success
   */
  actionsProductsSearchEndpoint(searchProductsRequest: SearchProductsRequest, accept_language?: string | null | undefined): Observable<SearchProductsResponse>;
  /**
   * @param accept_language (optional)
   * @return Success
   */
  actionsPeopleSearchEndpoint(searchPeopleRequest: SearchPeopleRequest, accept_language?: string | null | undefined): Observable<SearchPeopleResponse>;
  /**
   * @param idempotency_key Chave de idempotência, utilizada para controle cahce de requisições.
   * @param accept_language (optional)
   * @return Success
   */
  actionsPaymentsCreateEndpoint(idempotency_key: string, createPaymentRequest: CreatePaymentRequest, accept_language?: string | null | undefined): Observable<CreatePaymentResponse>;
  /**
   * @param organizationId Id da organização.
   * @param orgAppId Id do aplicativo instalado na organização.
   * @param actionId Id da `action` a ser executada.
   * @param id Chave de idempotência.
   * @param accept_language (optional)
   * @return Success
   */
  actionsPaymentsGetEndpoint(organizationId: string, orgAppId: string, actionId: string, id: string, accept_language?: string | null | undefined): Observable<any>;
}

@Injectable({
  providedIn: 'root'
})
export class OctopusClient extends HopperOctopusApiClient implements IOctopusClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HopperOctopusConfiguration) configuration: HopperOctopusConfiguration, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OctopusApiUrl) baseUrl?: string) {
    super(configuration);
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://octopus-meadow-bw2x.fly.dev");
  }

  /**
   * Lista as lojas disponíveis
   * @param name (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubStoreListEndpoint(name?: string | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<StoreListResponse> {
    let url_ = this.baseUrl + "/hub/stores?";
    if (name !== undefined && name !== null)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (orderBy !== undefined && orderBy !== null)
      url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubStoreListEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubStoreListEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<StoreListResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<StoreListResponse>;
    }));
  }

  protected processHubStoreListEndpoint(response: HttpResponseBase): Observable<StoreListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = StoreListResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Personaliza o modelo de uma action
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppActionCreateOrUpdateEndpoint(orgAppId: string, actionId: string, createOrUpdateOrgAppActionRequest: CreateOrUpdateOrgAppActionRequest, accept_language?: string | null | undefined): Observable<OrgAppActionResponse> {
    let url_ = this.baseUrl + "/hub/apps/installed/{orgAppId}/actions/{actionId}";
    if (orgAppId === undefined || orgAppId === null)
      throw new Error("The parameter 'orgAppId' must be defined.");
    url_ = url_.replace("{orgAppId}", encodeURIComponent("" + orgAppId));
    if (actionId === undefined || actionId === null)
      throw new Error("The parameter 'actionId' must be defined.");
    url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createOrUpdateOrgAppActionRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppActionCreateOrUpdateEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppActionCreateOrUpdateEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrgAppActionResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrgAppActionResponse>;
    }));
  }

  protected processHubOrgAppActionCreateOrUpdateEndpoint(response: HttpResponseBase): Observable<OrgAppActionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrgAppActionResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Created", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Apaga as configurações de uma action
   * @param accept_language (optional)
   * @return No Content
   */
  hubOrgAppActionDeleteEndpoint(orgAppId: string, actionId: string, accept_language?: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/hub/apps/installed/{orgAppId}/actions/{actionId}";
    if (orgAppId === undefined || orgAppId === null)
      throw new Error("The parameter 'orgAppId' must be defined.");
    url_ = url_.replace("{orgAppId}", encodeURIComponent("" + orgAppId));
    if (actionId === undefined || actionId === null)
      throw new Error("The parameter 'actionId' must be defined.");
    url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("delete", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppActionDeleteEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppActionDeleteEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processHubOrgAppActionDeleteEndpoint(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Pega as configurações de uma action
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppActionGetEndpoint(orgAppId: string, actionId: string, accept_language?: string | null | undefined): Observable<OrgAppActionResponse> {
    let url_ = this.baseUrl + "/hub/apps/installed/{orgAppId}/actions/{actionId}";
    if (orgAppId === undefined || orgAppId === null)
      throw new Error("The parameter 'orgAppId' must be defined.");
    url_ = url_.replace("{orgAppId}", encodeURIComponent("" + orgAppId));
    if (actionId === undefined || actionId === null)
      throw new Error("The parameter 'actionId' must be defined.");
    url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppActionGetEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppActionGetEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrgAppActionResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrgAppActionResponse>;
    }));
  }

  protected processHubOrgAppActionGetEndpoint(response: HttpResponseBase): Observable<OrgAppActionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrgAppActionResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Lista as actions de um aplicativo instalado
   * @param categoryId (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppActionListEndpoint(orgAppId: string, categoryId?: number | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<OrgAppActionListResponse> {
    let url_ = this.baseUrl + "/hub/apps/installed/{orgAppId}/actions?";
    if (orgAppId === undefined || orgAppId === null)
      throw new Error("The parameter 'orgAppId' must be defined.");
    url_ = url_.replace("{orgAppId}", encodeURIComponent("" + orgAppId));
    if (categoryId !== undefined && categoryId !== null)
      url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (orderBy !== undefined && orderBy !== null)
      url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppActionListEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppActionListEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrgAppActionListResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrgAppActionListResponse>;
    }));
  }

  protected processHubOrgAppActionListEndpoint(response: HttpResponseBase): Observable<OrgAppActionListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrgAppActionListResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Instala um aplicativo
   * @param accept_language (optional)
   * @return Created
   */
  hubOrgAppCreateEndpoint(createOrgAppRequest: CreateOrgAppRequest, accept_language?: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/hub/apps/installed";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createOrgAppRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppCreateEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppCreateEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processHubOrgAppCreateEndpoint(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 201) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Lista os aplicativos instalados
   * @param name (optional)
   * @param categoryId (optional)
   * @param status (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppListEndpoint(name?: string | null | undefined, categoryId?: number | null | undefined, status?: StatusType | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<OrgAppListResponse> {
    let url_ = this.baseUrl + "/hub/apps/installed?";
    if (name !== undefined && name !== null)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (categoryId !== undefined && categoryId !== null)
      url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
    if (status !== undefined && status !== null)
      url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (orderBy !== undefined && orderBy !== null)
      url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppListEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppListEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrgAppListResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrgAppListResponse>;
    }));
  }

  protected processHubOrgAppListEndpoint(response: HttpResponseBase): Observable<OrgAppListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrgAppListResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Desinstala um aplicativo
   * @param accept_language (optional)
   * @return No Content
   */
  hubOrgAppDeleteEndpoint(id: string, accept_language?: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + "/hub/apps/installed/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("delete", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppDeleteEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppDeleteEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<void>;
        }
      } else
        return _observableThrow(response_) as any as Observable<void>;
    }));
  }

  protected processHubOrgAppDeleteEndpoint(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return _observableOf(null as any);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Pega um aplicativo instalado
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppGetEndpoint(id: string, accept_language?: string | null | undefined): Observable<OrgAppResponse> {
    let url_ = this.baseUrl + "/hub/apps/installed/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppGetEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppGetEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrgAppResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrgAppResponse>;
    }));
  }

  protected processHubOrgAppGetEndpoint(response: HttpResponseBase): Observable<OrgAppResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrgAppResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Atualiza um aplicativo
   * @param accept_language (optional)
   * @return Success
   */
  hubOrgAppUpdateEndpoint(id: string, updateOrgAppRequest: UpdateOrgAppRequest, accept_language?: string | null | undefined): Observable<OrgAppResponse> {
    let url_ = this.baseUrl + "/hub/apps/installed/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(updateOrgAppRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrgAppUpdateEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrgAppUpdateEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrgAppResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrgAppResponse>;
    }));
  }

  protected processHubOrgAppUpdateEndpoint(response: HttpResponseBase): Observable<OrgAppResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrgAppResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Cria uma organização
   * @param accept_language (optional)
   * @return Success
   */
  hubOrganizationCreateEndpoint(createOrganizationRequest: CreateOrganizationRequest, accept_language?: string | null | undefined): Observable<OrganizationResponse> {
    let url_ = this.baseUrl + "/hub/organization";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createOrganizationRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrganizationCreateEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrganizationCreateEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationResponse>;
    }));
  }

  protected processHubOrganizationCreateEndpoint(response: HttpResponseBase): Observable<OrganizationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrganizationResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Pega a organização autal
   * @param accept_language (optional)
   * @return Success
   */
  hubOrganizationGetEndpoint(accept_language?: string | null | undefined): Observable<OrganizationResponse> {
    let url_ = this.baseUrl + "/hub/organization";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrganizationGetEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrganizationGetEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationResponse>;
    }));
  }

  protected processHubOrganizationGetEndpoint(response: HttpResponseBase): Observable<OrganizationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrganizationResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Atualiza a organização atual
   * @param accept_language (optional)
   * @return Success
   */
  hubOrganizationUpdateEndpoint(updateOrganizationRequest: UpdateOrganizationRequest, accept_language?: string | null | undefined): Observable<OrganizationResponse> {
    let url_ = this.baseUrl + "/hub/organization";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(updateOrganizationRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("put", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubOrganizationUpdateEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubOrganizationUpdateEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<OrganizationResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<OrganizationResponse>;
    }));
  }

  protected processHubOrganizationUpdateEndpoint(response: HttpResponseBase): Observable<OrganizationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = OrganizationResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Lista todos os aplicativos disponíveis
   * @param name (optional)
   * @param categoryId (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubApplicationListEndpoint(name?: string | null | undefined, categoryId?: number | null | undefined, accept_language?: string | null | undefined): Observable<ApplicationListResponse> {
    let url_ = this.baseUrl + "/hub/apps?";
    if (name !== undefined && name !== null)
      url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (categoryId !== undefined && categoryId !== null)
      url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubApplicationListEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubApplicationListEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ApplicationListResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ApplicationListResponse>;
    }));
  }

  protected processHubApplicationListEndpoint(response: HttpResponseBase): Observable<ApplicationListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ApplicationListResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * Lista todas as actions instaladas
   * @param applicationId (optional)
   * @param categoryId (optional)
   * @param sortBy (optional)
   * @param orderBy (optional)
   * @param page (optional)
   * @param pageSize (optional)
   * @param accept_language (optional)
   * @return Success
   */
  hubActionListEndpoint(applicationId?: string | null | undefined, categoryId?: number | null | undefined, sortBy?: SortMode | null | undefined, orderBy?: string | null | undefined, page?: number | null | undefined, pageSize?: number | null | undefined, accept_language?: string | null | undefined): Observable<ActionListResponse> {
    let url_ = this.baseUrl + "/hub/apps/installed/actions?";
    if (applicationId !== undefined && applicationId !== null)
      url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
    if (categoryId !== undefined && categoryId !== null)
      url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
    if (sortBy !== undefined && sortBy !== null)
      url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (orderBy !== undefined && orderBy !== null)
      url_ += "orderBy=" + encodeURIComponent("" + orderBy) + "&";
    if (page !== undefined && page !== null)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize !== undefined && pageSize !== null)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processHubActionListEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processHubActionListEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<ActionListResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<ActionListResponse>;
    }));
  }

  protected processHubActionListEndpoint(response: HttpResponseBase): Observable<ActionListResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ActionListResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param accept_language (optional)
   * @return Success
   */
  actionsProductsGetFiltersEndpoint(getProductFilterDataRequest: GetProductFilterDataRequest, accept_language?: string | null | undefined): Observable<GetProductFilterDataResponse> {
    let url_ = this.baseUrl + "/actions/products/filters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(getProductFilterDataRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processActionsProductsGetFiltersEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processActionsProductsGetFiltersEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<GetProductFilterDataResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<GetProductFilterDataResponse>;
    }));
  }

  protected processActionsProductsGetFiltersEndpoint(response: HttpResponseBase): Observable<GetProductFilterDataResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetProductFilterDataResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param accept_language (optional)
   * @return Success
   */
  actionsProductsSearchEndpoint(searchProductsRequest: SearchProductsRequest, accept_language?: string | null | undefined): Observable<SearchProductsResponse> {
    let url_ = this.baseUrl + "/actions/products/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(searchProductsRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processActionsProductsSearchEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processActionsProductsSearchEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SearchProductsResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SearchProductsResponse>;
    }));
  }

  protected processActionsProductsSearchEndpoint(response: HttpResponseBase): Observable<SearchProductsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchProductsResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param accept_language (optional)
   * @return Success
   */
  actionsPeopleSearchEndpoint(searchPeopleRequest: SearchPeopleRequest, accept_language?: string | null | undefined): Observable<SearchPeopleResponse> {
    let url_ = this.baseUrl + "/actions/people/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(searchPeopleRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processActionsPeopleSearchEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processActionsPeopleSearchEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<SearchPeopleResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<SearchPeopleResponse>;
    }));
  }

  protected processActionsPeopleSearchEndpoint(response: HttpResponseBase): Observable<SearchPeopleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchPeopleResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param idempotency_key Chave de idempotência, utilizada para controle cahce de requisições.
   * @param accept_language (optional)
   * @return Success
   */
  actionsPaymentsCreateEndpoint(idempotency_key: string, createPaymentRequest: CreatePaymentRequest, accept_language?: string | null | undefined): Observable<CreatePaymentResponse> {
    let url_ = this.baseUrl + "/actions/payments/new";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(createPaymentRequest);

    let options_ : any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "idempotency-key": idempotency_key !== undefined && idempotency_key !== null ? "" + idempotency_key : "",
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Content-Type": "application/json",
        "Accept": "application/json"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("post", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processActionsPaymentsCreateEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processActionsPaymentsCreateEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<CreatePaymentResponse>;
        }
      } else
        return _observableThrow(response_) as any as Observable<CreatePaymentResponse>;
    }));
  }

  protected processActionsPaymentsCreateEndpoint(response: HttpResponseBase): Observable<CreatePaymentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = CreatePaymentResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Unauthorized", status, _responseText, _headers);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result400: any = null;
        let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result400 = ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }

  /**
   * @param organizationId Id da organização.
   * @param orgAppId Id do aplicativo instalado na organização.
   * @param actionId Id da `action` a ser executada.
   * @param id Chave de idempotência.
   * @param accept_language (optional)
   * @return Success
   */
  actionsPaymentsGetEndpoint(organizationId: string, orgAppId: string, actionId: string, id: string, accept_language?: string | null | undefined): Observable<any> {
    let url_ = this.baseUrl + "/actions/payments/{organizationId}/{orgAppId}/{actionId}/{id}";
    if (organizationId === undefined || organizationId === null)
      throw new Error("The parameter 'organizationId' must be defined.");
    url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
    if (orgAppId === undefined || orgAppId === null)
      throw new Error("The parameter 'orgAppId' must be defined.");
    url_ = url_.replace("{orgAppId}", encodeURIComponent("" + orgAppId));
    if (actionId === undefined || actionId === null)
      throw new Error("The parameter 'actionId' must be defined.");
    url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ : any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "accept-language": accept_language !== undefined && accept_language !== null ? "" + accept_language : "",
        "Accept": "text/plain"
      })
    };

    return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
      return this.http.request("get", url_, transformedOptions_);
    })).pipe(_observableMergeMap((response_: any) => {
      return this.processActionsPaymentsGetEndpoint(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processActionsPaymentsGetEndpoint(response_ as any);
        } catch (e) {
          return _observableThrow(e) as any as Observable<any>;
        }
      } else
        return _observableThrow(response_) as any as Observable<any>;
    }));
  }

  protected processActionsPaymentsGetEndpoint(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
    if (status === 200) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return _observableOf(result200);
      }));
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Forbidden", status, _responseText, _headers);
      }));
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("Not Found", status, _responseText, _headers);
      }));
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        let result500: any = null;
        let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result500 = InternalErrorResponse.fromJS(resultData500);
        return throwException("Server Error", status, _responseText, _headers, result500);
      }));
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf(null as any);
  }
}

export class StoreListResponse implements IStoreListResponse {
  result?: StoreDto[];
  pagination?: Pagination | undefined;

  constructor(data?: IStoreListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.result) {
        this.result = [];
        for (let i = 0; i < data.result.length; i++) {
          let item = data.result[i];
          this.result[i] = item && !(<any>item).toJSON ? new StoreDto(item) : <StoreDto>item;
        }
      }
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result!.push(StoreDto.fromJS(item));
      }
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): StoreListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new StoreListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IStoreListResponse {
  result?: IStoreDto[];
  pagination?: IPagination | undefined;
}

export class StoreDto implements IStoreDto {
  id?: number;
  name?: string;
  description?: string | undefined;
  status?: StatusType;

  constructor(data?: IStoreDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): StoreDto {
    data = typeof data === 'object' ? data : {};
    let result = new StoreDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["status"] = this.status;
    return data;
  }
}

export interface IStoreDto {
  id?: number;
  name?: string;
  description?: string | undefined;
  status?: StatusType;
}

export enum StatusType {
  Inactive = "Inactive",
  Active = "Active",
  Deleted = "Deleted",
}

export class Pagination implements IPagination {
  page?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPrevious?: boolean;
  hasNext?: boolean;

  constructor(data?: IPagination) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data["page"];
      this.pageSize = _data["pageSize"];
      this.totalItems = _data["totalItems"];
      this.totalPages = _data["totalPages"];
      this.hasPrevious = _data["hasPrevious"];
      this.hasNext = _data["hasNext"];
    }
  }

  static fromJS(data: any): Pagination {
    data = typeof data === 'object' ? data : {};
    let result = new Pagination();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["page"] = this.page;
    data["pageSize"] = this.pageSize;
    data["totalItems"] = this.totalItems;
    data["totalPages"] = this.totalPages;
    data["hasPrevious"] = this.hasPrevious;
    data["hasNext"] = this.hasNext;
    return data;
  }
}

export interface IPagination {
  page?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPrevious?: boolean;
  hasNext?: boolean;
}

export class OrgAppActionResponse implements IOrgAppActionResponse {
  result?: ActionDto;
  pagination?: Pagination | undefined;

  constructor(data?: IOrgAppActionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.result = data.result && !(<any>data.result).toJSON ? new ActionDto(data.result) : <ActionDto>this.result;
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? ActionDto.fromJS(_data["result"]) : <any>undefined;
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): OrgAppActionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new OrgAppActionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IOrgAppActionResponse {
  result?: IActionDto;
  pagination?: IPagination | undefined;
}

export enum SortMode {
  Ascending = "Ascending",
  Descending = "Descending",
}

export class ActionDto implements IActionDto {
  id?: string;
  application?: ApplicationRelationshipDto;
  category?: CategoryRelationshipDto;
  name?: string;
  shortDescription?: string | undefined;
  description?: string | undefined;
  userSchema?: string;
  optionsSchema?: string;
  optionsModel?: string;
  status?: StatusType;
  createdAt?: Date;
  updatedAt?: Date;
  orgApp?: OrgAppRelationshipDto;
  orgAppAction?: OrgAppActionDto | undefined;

  constructor(data?: IActionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.application = data.application && !(<any>data.application).toJSON ? new ApplicationRelationshipDto(data.application) : <ApplicationRelationshipDto>this.application;
      this.category = data.category && !(<any>data.category).toJSON ? new CategoryRelationshipDto(data.category) : <CategoryRelationshipDto>this.category;
      this.orgApp = data.orgApp && !(<any>data.orgApp).toJSON ? new OrgAppRelationshipDto(data.orgApp) : <OrgAppRelationshipDto>this.orgApp;
      this.orgAppAction = data.orgAppAction && !(<any>data.orgAppAction).toJSON ? new OrgAppActionDto(data.orgAppAction) : <OrgAppActionDto>this.orgAppAction;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.application = _data["application"] ? ApplicationRelationshipDto.fromJS(_data["application"]) : <any>undefined;
      this.category = _data["category"] ? CategoryRelationshipDto.fromJS(_data["category"]) : <any>undefined;
      this.name = _data["name"];
      this.shortDescription = _data["shortDescription"];
      this.description = _data["description"];
      this.userSchema = _data["userSchema"];
      this.optionsSchema = _data["optionsSchema"];
      this.optionsModel = _data["optionsModel"];
      this.status = _data["status"];
      this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
      this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
      this.orgApp = _data["orgApp"] ? OrgAppRelationshipDto.fromJS(_data["orgApp"]) : <any>undefined;
      this.orgAppAction = _data["orgAppAction"] ? OrgAppActionDto.fromJS(_data["orgAppAction"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ActionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ActionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["application"] = this.application ? this.application.toJSON() : <any>undefined;
    data["category"] = this.category ? this.category.toJSON() : <any>undefined;
    data["name"] = this.name;
    data["shortDescription"] = this.shortDescription;
    data["description"] = this.description;
    data["userSchema"] = this.userSchema;
    data["optionsSchema"] = this.optionsSchema;
    data["optionsModel"] = this.optionsModel;
    data["status"] = this.status;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
    data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
    data["orgApp"] = this.orgApp ? this.orgApp.toJSON() : <any>undefined;
    data["orgAppAction"] = this.orgAppAction ? this.orgAppAction.toJSON() : <any>undefined;
    return data;
  }
}

export interface IActionDto {
  id?: string;
  application?: IApplicationRelationshipDto;
  category?: ICategoryRelationshipDto;
  name?: string;
  shortDescription?: string | undefined;
  description?: string | undefined;
  userSchema?: string;
  optionsSchema?: string;
  optionsModel?: string;
  status?: StatusType;
  createdAt?: Date;
  updatedAt?: Date;
  orgApp?: IOrgAppRelationshipDto;
  orgAppAction?: IOrgAppActionDto | undefined;
}

export class ApplicationRelationshipDto implements IApplicationRelationshipDto {
  id?: string;
  name?: string;
  shortDescription?: string | undefined;
  logoUrl?: string | undefined;

  constructor(data?: IApplicationRelationshipDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.shortDescription = _data["shortDescription"];
      this.logoUrl = _data["logoUrl"];
    }
  }

  static fromJS(data: any): ApplicationRelationshipDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationRelationshipDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["shortDescription"] = this.shortDescription;
    data["logoUrl"] = this.logoUrl;
    return data;
  }
}

export interface IApplicationRelationshipDto {
  id?: string;
  name?: string;
  shortDescription?: string | undefined;
  logoUrl?: string | undefined;
}

export class CategoryRelationshipDto implements ICategoryRelationshipDto {
  id?: number;
  name?: string;

  constructor(data?: ICategoryRelationshipDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CategoryRelationshipDto {
    data = typeof data === 'object' ? data : {};
    let result = new CategoryRelationshipDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface ICategoryRelationshipDto {
  id?: number;
  name?: string;
}

export class OrgAppRelationshipDto implements IOrgAppRelationshipDto {
  id?: string;
  displayName?: string;
  status?: StatusType;

  constructor(data?: IOrgAppRelationshipDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): OrgAppRelationshipDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrgAppRelationshipDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    data["status"] = this.status;
    return data;
  }
}

export interface IOrgAppRelationshipDto {
  id?: string;
  displayName?: string;
  status?: StatusType;
}

export class OrgAppActionDto implements IOrgAppActionDto {
  optionsModel?: string;

  constructor(data?: IOrgAppActionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.optionsModel = _data["optionsModel"];
    }
  }

  static fromJS(data: any): OrgAppActionDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrgAppActionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["optionsModel"] = this.optionsModel;
    return data;
  }
}

export interface IOrgAppActionDto {
  optionsModel?: string;
}

export class ProblemDetails implements IProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  instance?: string;
  traceId?: string;
  detail?: string | undefined;
  errors?: ProblemDetails_Error[];

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.errors) {
        this.errors = [];
        for (let i = 0; i < data.errors.length; i++) {
          let item = data.errors[i];
          this.errors[i] = item && !(<any>item).toJSON ? new ProblemDetails_Error(item) : <ProblemDetails_Error>item;
        }
      }
    }
    if (!data) {
      this.type = "https://www.rfc-editor.org/rfc/rfc7231#section-6.5.1";
      this.title = "One or more validation errors occurred.";
      this.status = 400;
      this.instance = "/api/route";
      this.traceId = "0HMPNHL0JHL76:00000001";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"] !== undefined ? _data["type"] : "https://www.rfc-editor.org/rfc/rfc7231#section-6.5.1";
      this.title = _data["title"] !== undefined ? _data["title"] : "One or more validation errors occurred.";
      this.status = _data["status"] !== undefined ? _data["status"] : 400;
      this.instance = _data["instance"] !== undefined ? _data["instance"] : "/api/route";
      this.traceId = _data["traceId"] !== undefined ? _data["traceId"] : "0HMPNHL0JHL76:00000001";
      this.detail = _data["detail"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"])
          this.errors!.push(ProblemDetails_Error.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["instance"] = this.instance;
    data["traceId"] = this.traceId;
    data["detail"] = this.detail;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors)
        data["errors"].push(item.toJSON());
    }
    return data;
  }
}

export interface IProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  instance?: string;
  traceId?: string;
  detail?: string | undefined;
  errors?: IProblemDetails_Error[];
}

export class ProblemDetails_Error implements IProblemDetails_Error {
  name?: string;
  reason?: string;
  code?: string | undefined;
  severity?: string | undefined;

  constructor(data?: IProblemDetails_Error) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.name = "Error or field name";
      this.reason = "Error reason";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : "Error or field name";
      this.reason = _data["reason"] !== undefined ? _data["reason"] : "Error reason";
      this.code = _data["code"];
      this.severity = _data["severity"];
    }
  }

  static fromJS(data: any): ProblemDetails_Error {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails_Error();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["reason"] = this.reason;
    data["code"] = this.code;
    data["severity"] = this.severity;
    return data;
  }
}

export interface IProblemDetails_Error {
  name?: string;
  reason?: string;
  code?: string | undefined;
  severity?: string | undefined;
}

export class CreateOrUpdateOrgAppActionRequest implements ICreateOrUpdateOrgAppActionRequest {
  optionsModel?: string;

  constructor(data?: ICreateOrUpdateOrgAppActionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.optionsModel = _data["optionsModel"];
    }
  }

  static fromJS(data: any): CreateOrUpdateOrgAppActionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateOrgAppActionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["optionsModel"] = this.optionsModel;
    return data;
  }
}

export interface ICreateOrUpdateOrgAppActionRequest {
  optionsModel?: string;
}

export class OrgAppActionListResponse implements IOrgAppActionListResponse {
  result?: ActionDto[];
  pagination?: Pagination | undefined;

  constructor(data?: IOrgAppActionListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.result) {
        this.result = [];
        for (let i = 0; i < data.result.length; i++) {
          let item = data.result[i];
          this.result[i] = item && !(<any>item).toJSON ? new ActionDto(item) : <ActionDto>item;
        }
      }
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result!.push(ActionDto.fromJS(item));
      }
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): OrgAppActionListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new OrgAppActionListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IOrgAppActionListResponse {
  result?: IActionDto[];
  pagination?: IPagination | undefined;
}

export class InternalErrorResponse implements IInternalErrorResponse {
  status?: string;
  code?: number;
  reason?: string;
  note?: string;

  constructor(data?: IInternalErrorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.status = "Internal Server Error!";
      this.code = 500;
      this.reason = "Something unexpected has happened";
      this.note = "See application log for stack trace.";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data["status"] !== undefined ? _data["status"] : "Internal Server Error!";
      this.code = _data["code"] !== undefined ? _data["code"] : 500;
      this.reason = _data["reason"] !== undefined ? _data["reason"] : "Something unexpected has happened";
      this.note = _data["note"] !== undefined ? _data["note"] : "See application log for stack trace.";
    }
  }

  static fromJS(data: any): InternalErrorResponse {
    data = typeof data === 'object' ? data : {};
    let result = new InternalErrorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["status"] = this.status;
    data["code"] = this.code;
    data["reason"] = this.reason;
    data["note"] = this.note;
    return data;
  }
}

export interface IInternalErrorResponse {
  status?: string;
  code?: number;
  reason?: string;
  note?: string;
}

export class CreateOrgAppRequest implements ICreateOrgAppRequest {
  applicationId?: string;
  displayName?: string | undefined;
  optionsModel?: string;

  constructor(data?: ICreateOrgAppRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationId = _data["applicationId"];
      this.displayName = _data["displayName"];
      this.optionsModel = _data["optionsModel"];
    }
  }

  static fromJS(data: any): CreateOrgAppRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrgAppRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["applicationId"] = this.applicationId;
    data["displayName"] = this.displayName;
    data["optionsModel"] = this.optionsModel;
    return data;
  }
}

export interface ICreateOrgAppRequest {
  applicationId?: string;
  displayName?: string | undefined;
  optionsModel?: string;
}

export class OrgAppResponse implements IOrgAppResponse {
  result?: OrgAppDto;
  pagination?: Pagination | undefined;

  constructor(data?: IOrgAppResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.result = data.result && !(<any>data.result).toJSON ? new OrgAppDto(data.result) : <OrgAppDto>this.result;
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? OrgAppDto.fromJS(_data["result"]) : <any>undefined;
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): OrgAppResponse {
    data = typeof data === 'object' ? data : {};
    let result = new OrgAppResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IOrgAppResponse {
  result?: IOrgAppDto;
  pagination?: IPagination | undefined;
}

export class OrgAppDto implements IOrgAppDto {
  id?: string;
  displayName?: string;
  optionsModel?: string;
  status?: StatusType;
  createdAt?: Date;
  updatedAt?: Date;
  application?: ApplicationDto;

  constructor(data?: IOrgAppDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.application = data.application && !(<any>data.application).toJSON ? new ApplicationDto(data.application) : <ApplicationDto>this.application;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.displayName = _data["displayName"];
      this.optionsModel = _data["optionsModel"];
      this.status = _data["status"];
      this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
      this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
      this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
    }
  }

  static fromJS(data: any): OrgAppDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrgAppDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["displayName"] = this.displayName;
    data["optionsModel"] = this.optionsModel;
    data["status"] = this.status;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
    data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
    data["application"] = this.application ? this.application.toJSON() : <any>undefined;
    return data;
  }
}

export interface IOrgAppDto {
  id?: string;
  displayName?: string;
  optionsModel?: string;
  status?: StatusType;
  createdAt?: Date;
  updatedAt?: Date;
  application?: IApplicationDto;
}

export class ApplicationDto implements IApplicationDto {
  id?: string;
  name?: string;
  shortDescription?: string | undefined;
  description?: string | undefined;
  optionsSchema?: string;
  version?: string;
  logoUrl?: string | undefined;
  installationMode?: InstallationMode;
  allowMultiple?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  category?: CategoryRelationshipDto;
  orgApp?: OrgAppRelationshipDto | undefined;

  constructor(data?: IApplicationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.category = data.category && !(<any>data.category).toJSON ? new CategoryRelationshipDto(data.category) : <CategoryRelationshipDto>this.category;
      this.orgApp = data.orgApp && !(<any>data.orgApp).toJSON ? new OrgAppRelationshipDto(data.orgApp) : <OrgAppRelationshipDto>this.orgApp;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.shortDescription = _data["shortDescription"];
      this.description = _data["description"];
      this.optionsSchema = _data["optionsSchema"];
      this.version = _data["version"];
      this.logoUrl = _data["logoUrl"];
      this.installationMode = _data["installationMode"];
      this.allowMultiple = _data["allowMultiple"];
      this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
      this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
      this.category = _data["category"] ? CategoryRelationshipDto.fromJS(_data["category"]) : <any>undefined;
      this.orgApp = _data["orgApp"] ? OrgAppRelationshipDto.fromJS(_data["orgApp"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ApplicationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["shortDescription"] = this.shortDescription;
    data["description"] = this.description;
    data["optionsSchema"] = this.optionsSchema;
    data["version"] = this.version;
    data["logoUrl"] = this.logoUrl;
    data["installationMode"] = this.installationMode;
    data["allowMultiple"] = this.allowMultiple;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
    data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
    data["category"] = this.category ? this.category.toJSON() : <any>undefined;
    data["orgApp"] = this.orgApp ? this.orgApp.toJSON() : <any>undefined;
    return data;
  }
}

export interface IApplicationDto {
  id?: string;
  name?: string;
  shortDescription?: string | undefined;
  description?: string | undefined;
  optionsSchema?: string;
  version?: string;
  logoUrl?: string | undefined;
  installationMode?: InstallationMode;
  allowMultiple?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  category?: ICategoryRelationshipDto;
  orgApp?: IOrgAppRelationshipDto | undefined;
}

export enum InstallationMode {
  Manual = "Manual",
  Automatic = "Automatic",
}

export class OrgAppListResponse implements IOrgAppListResponse {
  result?: OrgAppDto[];
  pagination?: Pagination | undefined;

  constructor(data?: IOrgAppListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.result) {
        this.result = [];
        for (let i = 0; i < data.result.length; i++) {
          let item = data.result[i];
          this.result[i] = item && !(<any>item).toJSON ? new OrgAppDto(item) : <OrgAppDto>item;
        }
      }
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result!.push(OrgAppDto.fromJS(item));
      }
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): OrgAppListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new OrgAppListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IOrgAppListResponse {
  result?: IOrgAppDto[];
  pagination?: IPagination | undefined;
}

export class UpdateOrgAppRequest implements IUpdateOrgAppRequest {
  displayName?: string | undefined;
  optionsModel?: string;
  status?: StatusType;

  constructor(data?: IUpdateOrgAppRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.status = StatusType.Active;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data["displayName"];
      this.optionsModel = _data["optionsModel"];
      this.status = _data["status"] !== undefined ? _data["status"] : StatusType.Active;
    }
  }

  static fromJS(data: any): UpdateOrgAppRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateOrgAppRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["displayName"] = this.displayName;
    data["optionsModel"] = this.optionsModel;
    data["status"] = this.status;
    return data;
  }
}

export interface IUpdateOrgAppRequest {
  displayName?: string | undefined;
  optionsModel?: string;
  status?: StatusType;
}

export class OrganizationResponse implements IOrganizationResponse {
  result?: OrganizationDto;
  pagination?: Pagination | undefined;

  constructor(data?: IOrganizationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.result = data.result && !(<any>data.result).toJSON ? new OrganizationDto(data.result) : <OrganizationDto>this.result;
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? OrganizationDto.fromJS(_data["result"]) : <any>undefined;
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): OrganizationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IOrganizationResponse {
  result?: IOrganizationDto;
  pagination?: IPagination | undefined;
}

export class OrganizationDto implements IOrganizationDto {
  id?: string;
  name?: string;
  displayName?: string;
  commonId?: string | undefined;
  store?: StoreRelationshipDto | undefined;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(data?: IOrganizationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.store = data.store && !(<any>data.store).toJSON ? new StoreRelationshipDto(data.store) : <StoreRelationshipDto>this.store;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.commonId = _data["commonId"];
      this.store = _data["store"] ? StoreRelationshipDto.fromJS(_data["store"]) : <any>undefined;
      this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
      this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): OrganizationDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["commonId"] = this.commonId;
    data["store"] = this.store ? this.store.toJSON() : <any>undefined;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
    data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
    return data;
  }
}

export interface IOrganizationDto {
  id?: string;
  name?: string;
  displayName?: string;
  commonId?: string | undefined;
  store?: IStoreRelationshipDto | undefined;
  createdAt?: Date;
  updatedAt?: Date;
}

export class StoreRelationshipDto implements IStoreRelationshipDto {
  id?: number;
  name?: string;

  constructor(data?: IStoreRelationshipDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): StoreRelationshipDto {
    data = typeof data === 'object' ? data : {};
    let result = new StoreRelationshipDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IStoreRelationshipDto {
  id?: number;
  name?: string;
}

export class CreateOrganizationRequest implements ICreateOrganizationRequest {
  name?: string;
  displayName?: string;
  storeId?: number;
  commonId?: string | undefined;
  baseUrl?: string;
  clientId?: string;
  clientSecret?: string;

  constructor(data?: ICreateOrganizationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.storeId = _data["storeId"];
      this.commonId = _data["commonId"];
      this.baseUrl = _data["baseUrl"];
      this.clientId = _data["clientId"];
      this.clientSecret = _data["clientSecret"];
    }
  }

  static fromJS(data: any): CreateOrganizationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrganizationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["storeId"] = this.storeId;
    data["commonId"] = this.commonId;
    data["baseUrl"] = this.baseUrl;
    data["clientId"] = this.clientId;
    data["clientSecret"] = this.clientSecret;
    return data;
  }
}

export interface ICreateOrganizationRequest {
  name?: string;
  displayName?: string;
  storeId?: number;
  commonId?: string | undefined;
  baseUrl?: string;
  clientId?: string;
  clientSecret?: string;
}

export class UpdateOrganizationRequest implements IUpdateOrganizationRequest {
  name?: string;
  displayName?: string;
  commonId?: string | undefined;
  storeId?: number;

  constructor(data?: IUpdateOrganizationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.commonId = _data["commonId"];
      this.storeId = _data["storeId"];
    }
  }

  static fromJS(data: any): UpdateOrganizationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateOrganizationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["commonId"] = this.commonId;
    data["storeId"] = this.storeId;
    return data;
  }
}

export interface IUpdateOrganizationRequest {
  name?: string;
  displayName?: string;
  commonId?: string | undefined;
  storeId?: number;
}

export class ApplicationListResponse implements IApplicationListResponse {
  result?: ApplicationDto[];
  pagination?: Pagination | undefined;

  constructor(data?: IApplicationListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.result) {
        this.result = [];
        for (let i = 0; i < data.result.length; i++) {
          let item = data.result[i];
          this.result[i] = item && !(<any>item).toJSON ? new ApplicationDto(item) : <ApplicationDto>item;
        }
      }
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result!.push(ApplicationDto.fromJS(item));
      }
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ApplicationListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IApplicationListResponse {
  result?: IApplicationDto[];
  pagination?: IPagination | undefined;
}

export class ActionListResponse implements IActionListResponse {
  result?: ActionDto[];
  pagination?: Pagination | undefined;

  constructor(data?: IActionListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.result) {
        this.result = [];
        for (let i = 0; i < data.result.length; i++) {
          let item = data.result[i];
          this.result[i] = item && !(<any>item).toJSON ? new ActionDto(item) : <ActionDto>item;
        }
      }
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result!.push(ActionDto.fromJS(item));
      }
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ActionListResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ActionListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item.toJSON());
    }
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IActionListResponse {
  result?: IActionDto[];
  pagination?: IPagination | undefined;
}

export class GetProductFilterDataResponse implements IGetProductFilterDataResponse {
  result?: GetProductFilterDataOutput;
  pagination?: Pagination | undefined;

  constructor(data?: IGetProductFilterDataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.result = data.result && !(<any>data.result).toJSON ? new GetProductFilterDataOutput(data.result) : <GetProductFilterDataOutput>this.result;
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? GetProductFilterDataOutput.fromJS(_data["result"]) : <any>undefined;
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetProductFilterDataResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetProductFilterDataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetProductFilterDataResponse {
  result?: IGetProductFilterDataOutput;
  pagination?: IPagination | undefined;
}

export class GetProductFilterDataOutput implements IGetProductFilterDataOutput {
  schema?: string;

  constructor(data?: IGetProductFilterDataOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schema = _data["schema"];
    }
  }

  static fromJS(data: any): GetProductFilterDataOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetProductFilterDataOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["schema"] = this.schema;
    return data;
  }
}

export interface IGetProductFilterDataOutput {
  schema?: string;
}

export class GetProductFilterDataRequest implements IGetProductFilterDataRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId?: string;
  /** Id da `action` a ser executada. */
  actionId?: string;
  /** Chave de idempotência, utilizada para controle de requisições, deve ser única por requisição,
   caso se repita, sempre será retornado os mesmos dados. */
  idempotencyKey?: string | undefined;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;

  constructor(data?: IGetProductFilterDataRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.userSchema = "{}";
      this.userModel = "{}";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orgAppId = _data["orgAppId"];
      this.actionId = _data["actionId"];
      this.idempotencyKey = _data["idempotencyKey"];
      this.userSchema = _data["userSchema"] !== undefined ? _data["userSchema"] : "{}";
      this.userModel = _data["userModel"] !== undefined ? _data["userModel"] : "{}";
    }
  }

  static fromJS(data: any): GetProductFilterDataRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GetProductFilterDataRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orgAppId"] = this.orgAppId;
    data["actionId"] = this.actionId;
    data["idempotencyKey"] = this.idempotencyKey;
    data["userSchema"] = this.userSchema;
    data["userModel"] = this.userModel;
    return data;
  }
}

export interface IGetProductFilterDataRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId?: string;
  /** Id da `action` a ser executada. */
  actionId?: string;
  /** Chave de idempotência, utilizada para controle de requisições, deve ser única por requisição,
   caso se repita, sempre será retornado os mesmos dados. */
  idempotencyKey?: string | undefined;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;
}

export class SearchProductsResponse implements ISearchProductsResponse {
  result?: SearchProductsOutput;
  pagination?: Pagination | undefined;

  constructor(data?: ISearchProductsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.result = data.result && !(<any>data.result).toJSON ? new SearchProductsOutput(data.result) : <SearchProductsOutput>this.result;
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? SearchProductsOutput.fromJS(_data["result"]) : <any>undefined;
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SearchProductsResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SearchProductsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISearchProductsResponse {
  result?: ISearchProductsOutput;
  pagination?: IPagination | undefined;
}

export class SearchProductsOutput implements ISearchProductsOutput {
  items?: ProductSchema[];

  constructor(data?: ISearchProductsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.items) {
        this.items = [];
        for (let i = 0; i < data.items.length; i++) {
          let item = data.items[i];
          this.items[i] = item && !(<any>item).toJSON ? new ProductSchema(item) : <ProductSchema>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(ProductSchema.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SearchProductsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new SearchProductsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface ISearchProductsOutput {
  items?: IProductSchema[];
}

export class ProductSchema implements IProductSchema {
  id?: string | undefined;
  productType?: ProductType;
  sku?: string | undefined;
  barcode?: string | undefined;
  name?: string | undefined;
  alternateName?: string | undefined;
  description?: string | undefined;
  brand?: string | undefined;
  manufacturer?: string | undefined;
  mpn?: string | undefined;
  model?: string | undefined;
  width?: number | undefined;
  height?: number | undefined;
  depth?: number | undefined;
  area?: number | undefined;
  weight?: number | undefined;
  amount?: number | undefined;
  unit?: string | undefined;
  ncm?: string | undefined;
  availability?: ItemAvailability | undefined;
  availabilityStarts?: Date | undefined;
  availabilityEnds?: Date | undefined;
  cost?: number | undefined;
  price?: number | undefined;
  additionalProperties?: { [key: string]: any; } | undefined;
  kitComposition?: ProductSchema[] | undefined;
  attachments?: AttachmentSchema[] | undefined;

  constructor(data?: IProductSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.kitComposition) {
        this.kitComposition = [];
        for (let i = 0; i < data.kitComposition.length; i++) {
          let item = data.kitComposition[i];
          this.kitComposition[i] = item && !(<any>item).toJSON ? new ProductSchema(item) : <ProductSchema>item;
        }
      }
      if (data.attachments) {
        this.attachments = [];
        for (let i = 0; i < data.attachments.length; i++) {
          let item = data.attachments[i];
          this.attachments[i] = item && !(<any>item).toJSON ? new AttachmentSchema(item) : <AttachmentSchema>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.productType = _data["productType"];
      this.sku = _data["sku"];
      this.barcode = _data["barcode"];
      this.name = _data["name"];
      this.alternateName = _data["alternateName"];
      this.description = _data["description"];
      this.brand = _data["brand"];
      this.manufacturer = _data["manufacturer"];
      this.mpn = _data["mpn"];
      this.model = _data["model"];
      this.width = _data["width"];
      this.height = _data["height"];
      this.depth = _data["depth"];
      this.area = _data["area"];
      this.weight = _data["weight"];
      this.amount = _data["amount"];
      this.unit = _data["unit"];
      this.ncm = _data["ncm"];
      this.availability = _data["availability"];
      this.availabilityStarts = _data["availabilityStarts"] ? new Date(_data["availabilityStarts"].toString()) : <any>undefined;
      this.availabilityEnds = _data["availabilityEnds"] ? new Date(_data["availabilityEnds"].toString()) : <any>undefined;
      this.cost = _data["cost"];
      this.price = _data["price"];
      if (_data["additionalProperties"]) {
        this.additionalProperties = {} as any;
        for (let key in _data["additionalProperties"]) {
          if (_data["additionalProperties"].hasOwnProperty(key))
            (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
        }
      }
      if (Array.isArray(_data["kitComposition"])) {
        this.kitComposition = [] as any;
        for (let item of _data["kitComposition"])
          this.kitComposition!.push(ProductSchema.fromJS(item));
      }
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments!.push(AttachmentSchema.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProductSchema {
    data = typeof data === 'object' ? data : {};
    let result = new ProductSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["productType"] = this.productType;
    data["sku"] = this.sku;
    data["barcode"] = this.barcode;
    data["name"] = this.name;
    data["alternateName"] = this.alternateName;
    data["description"] = this.description;
    data["brand"] = this.brand;
    data["manufacturer"] = this.manufacturer;
    data["mpn"] = this.mpn;
    data["model"] = this.model;
    data["width"] = this.width;
    data["height"] = this.height;
    data["depth"] = this.depth;
    data["area"] = this.area;
    data["weight"] = this.weight;
    data["amount"] = this.amount;
    data["unit"] = this.unit;
    data["ncm"] = this.ncm;
    data["availability"] = this.availability;
    data["availabilityStarts"] = this.availabilityStarts ? this.availabilityStarts.toISOString() : <any>undefined;
    data["availabilityEnds"] = this.availabilityEnds ? this.availabilityEnds.toISOString() : <any>undefined;
    data["cost"] = this.cost;
    data["price"] = this.price;
    if (this.additionalProperties) {
      data["additionalProperties"] = {};
      for (let key in this.additionalProperties) {
        if (this.additionalProperties.hasOwnProperty(key))
          (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
      }
    }
    if (Array.isArray(this.kitComposition)) {
      data["kitComposition"] = [];
      for (let item of this.kitComposition)
        data["kitComposition"].push(item.toJSON());
    }
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    return data;
  }
}

export interface IProductSchema {
  id?: string | undefined;
  productType?: ProductType;
  sku?: string | undefined;
  barcode?: string | undefined;
  name?: string | undefined;
  alternateName?: string | undefined;
  description?: string | undefined;
  brand?: string | undefined;
  manufacturer?: string | undefined;
  mpn?: string | undefined;
  model?: string | undefined;
  width?: number | undefined;
  height?: number | undefined;
  depth?: number | undefined;
  area?: number | undefined;
  weight?: number | undefined;
  amount?: number | undefined;
  unit?: string | undefined;
  ncm?: string | undefined;
  availability?: ItemAvailability | undefined;
  availabilityStarts?: Date | undefined;
  availabilityEnds?: Date | undefined;
  cost?: number | undefined;
  price?: number | undefined;
  additionalProperties?: { [key: string]: any; } | undefined;
  kitComposition?: IProductSchema[] | undefined;
  attachments?: IAttachmentSchema[] | undefined;
}

export enum ProductType {
  Undefined = "Undefined",
  Single = "Single",
  Kit = "Kit",
}

export enum ItemAvailability {
  BackOrder = "BackOrder",
  Discontinued = "Discontinued",
  InStock = "InStock",
  InStoreOnly = "InStoreOnly",
  LimitedAvailability = "LimitedAvailability",
  OnlineOnly = "OnlineOnly",
  OutOfStock = "OutOfStock",
  PreOrder = "PreOrder",
  PreSale = "PreSale",
  SoldOut = "SoldOut",
}

export class AttachmentSchema implements IAttachmentSchema {
  attachmentId?: string | undefined;
  attachmentType?: AttachmentType;
  contentType?: string | undefined;
  data?: string;

  constructor(data?: IAttachmentSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.attachmentId = _data["attachmentId"];
      this.attachmentType = _data["attachmentType"];
      this.contentType = _data["contentType"];
      this.data = _data["data"];
    }
  }

  static fromJS(data: any): AttachmentSchema {
    data = typeof data === 'object' ? data : {};
    let result = new AttachmentSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["attachmentId"] = this.attachmentId;
    data["attachmentType"] = this.attachmentType;
    data["contentType"] = this.contentType;
    data["data"] = this.data;
    return data;
  }
}

export interface IAttachmentSchema {
  attachmentId?: string | undefined;
  attachmentType?: AttachmentType;
  contentType?: string | undefined;
  data?: string;
}

export enum AttachmentType {
  Undefined = "Undefined",
  ImageFile = "ImageFile",
  ImageBase64 = "ImageBase64",
  PdfFile = "PdfFile",
}

export class SearchProductsRequest implements ISearchProductsRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId?: string;
  /** Id da `action` a ser executada. */
  actionId?: string;
  /** Chave de idempotência, utilizada para controle de requisições, deve ser única por requisição,
   caso se repita, sempre será retornado os mesmos dados. */
  idempotencyKey?: string | undefined;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;
  /** Código IGBE da Cidade. */
  cityCode!: string;

  constructor(data?: ISearchProductsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.userSchema = "{}";
      this.userModel = "{}";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orgAppId = _data["orgAppId"];
      this.actionId = _data["actionId"];
      this.idempotencyKey = _data["idempotencyKey"];
      this.userSchema = _data["userSchema"] !== undefined ? _data["userSchema"] : "{}";
      this.userModel = _data["userModel"] !== undefined ? _data["userModel"] : "{}";
      this.cityCode = _data["cityCode"];
    }
  }

  static fromJS(data: any): SearchProductsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchProductsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orgAppId"] = this.orgAppId;
    data["actionId"] = this.actionId;
    data["idempotencyKey"] = this.idempotencyKey;
    data["userSchema"] = this.userSchema;
    data["userModel"] = this.userModel;
    data["cityCode"] = this.cityCode;
    return data;
  }
}

export interface ISearchProductsRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId?: string;
  /** Id da `action` a ser executada. */
  actionId?: string;
  /** Chave de idempotência, utilizada para controle de requisições, deve ser única por requisição,
   caso se repita, sempre será retornado os mesmos dados. */
  idempotencyKey?: string | undefined;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;
  /** Código IGBE da Cidade. */
  cityCode: string;
}

export class SearchPeopleResponse implements ISearchPeopleResponse {
  result?: SearchOrganizationsOutput;
  pagination?: Pagination | undefined;

  constructor(data?: ISearchPeopleResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.result = data.result && !(<any>data.result).toJSON ? new SearchOrganizationsOutput(data.result) : <SearchOrganizationsOutput>this.result;
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? SearchOrganizationsOutput.fromJS(_data["result"]) : <any>undefined;
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SearchPeopleResponse {
    data = typeof data === 'object' ? data : {};
    let result = new SearchPeopleResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISearchPeopleResponse {
  result?: ISearchOrganizationsOutput;
  pagination?: IPagination | undefined;
}

export class SearchOrganizationsOutput implements ISearchOrganizationsOutput {
  id?: string | undefined;
  name?: string | undefined;
  alternateName?: string | undefined;
  legalName?: string | undefined;
  email?: EmailSchema | undefined;
  alternativeEmails?: EmailSchema[] | undefined;
  phoneNumber?: PhoneNumberSchema | undefined;
  alternativePhoneNumbers?: PhoneNumberSchema[] | undefined;
  address?: AddressSchema | undefined;
  alternativeAddresses?: AddressSchema[] | undefined;
  taxId?: string | undefined;
  headquarters?: boolean | undefined;
  foundingDate?: Date | undefined;
  shareEquity?: number | undefined;
  partners?: OrganizationSchema_PartnerSchema[] | undefined;
  activities?: OrganizationSchema_ActivitySchema[] | undefined;
  registrations?: OrganizationSchema_RegistrationSchema[] | undefined;
  situations?: OrganizationSchema_SituationSchema[] | undefined;
  updateAt?: Date | undefined;
  additionalProperties?: { [key: string]: any; } | undefined;
  attachments?: AttachmentSchema[] | undefined;
  note?: string | undefined;

  constructor(data?: ISearchOrganizationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.email = data.email && !(<any>data.email).toJSON ? new EmailSchema(data.email) : <EmailSchema>this.email;
      if (data.alternativeEmails) {
        this.alternativeEmails = [];
        for (let i = 0; i < data.alternativeEmails.length; i++) {
          let item = data.alternativeEmails[i];
          this.alternativeEmails[i] = item && !(<any>item).toJSON ? new EmailSchema(item) : <EmailSchema>item;
        }
      }
      this.phoneNumber = data.phoneNumber && !(<any>data.phoneNumber).toJSON ? new PhoneNumberSchema(data.phoneNumber) : <PhoneNumberSchema>this.phoneNumber;
      if (data.alternativePhoneNumbers) {
        this.alternativePhoneNumbers = [];
        for (let i = 0; i < data.alternativePhoneNumbers.length; i++) {
          let item = data.alternativePhoneNumbers[i];
          this.alternativePhoneNumbers[i] = item && !(<any>item).toJSON ? new PhoneNumberSchema(item) : <PhoneNumberSchema>item;
        }
      }
      this.address = data.address && !(<any>data.address).toJSON ? new AddressSchema(data.address) : <AddressSchema>this.address;
      if (data.alternativeAddresses) {
        this.alternativeAddresses = [];
        for (let i = 0; i < data.alternativeAddresses.length; i++) {
          let item = data.alternativeAddresses[i];
          this.alternativeAddresses[i] = item && !(<any>item).toJSON ? new AddressSchema(item) : <AddressSchema>item;
        }
      }
      if (data.partners) {
        this.partners = [];
        for (let i = 0; i < data.partners.length; i++) {
          let item = data.partners[i];
          this.partners[i] = item && !(<any>item).toJSON ? new OrganizationSchema_PartnerSchema(item) : <OrganizationSchema_PartnerSchema>item;
        }
      }
      if (data.activities) {
        this.activities = [];
        for (let i = 0; i < data.activities.length; i++) {
          let item = data.activities[i];
          this.activities[i] = item && !(<any>item).toJSON ? new OrganizationSchema_ActivitySchema(item) : <OrganizationSchema_ActivitySchema>item;
        }
      }
      if (data.registrations) {
        this.registrations = [];
        for (let i = 0; i < data.registrations.length; i++) {
          let item = data.registrations[i];
          this.registrations[i] = item && !(<any>item).toJSON ? new OrganizationSchema_RegistrationSchema(item) : <OrganizationSchema_RegistrationSchema>item;
        }
      }
      if (data.situations) {
        this.situations = [];
        for (let i = 0; i < data.situations.length; i++) {
          let item = data.situations[i];
          this.situations[i] = item && !(<any>item).toJSON ? new OrganizationSchema_SituationSchema(item) : <OrganizationSchema_SituationSchema>item;
        }
      }
      if (data.attachments) {
        this.attachments = [];
        for (let i = 0; i < data.attachments.length; i++) {
          let item = data.attachments[i];
          this.attachments[i] = item && !(<any>item).toJSON ? new AttachmentSchema(item) : <AttachmentSchema>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.alternateName = _data["alternateName"];
      this.legalName = _data["legalName"];
      this.email = _data["email"] ? EmailSchema.fromJS(_data["email"]) : <any>undefined;
      if (Array.isArray(_data["alternativeEmails"])) {
        this.alternativeEmails = [] as any;
        for (let item of _data["alternativeEmails"])
          this.alternativeEmails!.push(EmailSchema.fromJS(item));
      }
      this.phoneNumber = _data["phoneNumber"] ? PhoneNumberSchema.fromJS(_data["phoneNumber"]) : <any>undefined;
      if (Array.isArray(_data["alternativePhoneNumbers"])) {
        this.alternativePhoneNumbers = [] as any;
        for (let item of _data["alternativePhoneNumbers"])
          this.alternativePhoneNumbers!.push(PhoneNumberSchema.fromJS(item));
      }
      this.address = _data["address"] ? AddressSchema.fromJS(_data["address"]) : <any>undefined;
      if (Array.isArray(_data["alternativeAddresses"])) {
        this.alternativeAddresses = [] as any;
        for (let item of _data["alternativeAddresses"])
          this.alternativeAddresses!.push(AddressSchema.fromJS(item));
      }
      this.taxId = _data["taxId"];
      this.headquarters = _data["headquarters"];
      this.foundingDate = _data["foundingDate"] ? new Date(_data["foundingDate"].toString()) : <any>undefined;
      this.shareEquity = _data["shareEquity"];
      if (Array.isArray(_data["partners"])) {
        this.partners = [] as any;
        for (let item of _data["partners"])
          this.partners!.push(OrganizationSchema_PartnerSchema.fromJS(item));
      }
      if (Array.isArray(_data["activities"])) {
        this.activities = [] as any;
        for (let item of _data["activities"])
          this.activities!.push(OrganizationSchema_ActivitySchema.fromJS(item));
      }
      if (Array.isArray(_data["registrations"])) {
        this.registrations = [] as any;
        for (let item of _data["registrations"])
          this.registrations!.push(OrganizationSchema_RegistrationSchema.fromJS(item));
      }
      if (Array.isArray(_data["situations"])) {
        this.situations = [] as any;
        for (let item of _data["situations"])
          this.situations!.push(OrganizationSchema_SituationSchema.fromJS(item));
      }
      this.updateAt = _data["updateAt"] ? new Date(_data["updateAt"].toString()) : <any>undefined;
      if (_data["additionalProperties"]) {
        this.additionalProperties = {} as any;
        for (let key in _data["additionalProperties"]) {
          if (_data["additionalProperties"].hasOwnProperty(key))
            (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
        }
      }
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments!.push(AttachmentSchema.fromJS(item));
      }
      this.note = _data["note"];
    }
  }

  static fromJS(data: any): SearchOrganizationsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new SearchOrganizationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["alternateName"] = this.alternateName;
    data["legalName"] = this.legalName;
    data["email"] = this.email ? this.email.toJSON() : <any>undefined;
    if (Array.isArray(this.alternativeEmails)) {
      data["alternativeEmails"] = [];
      for (let item of this.alternativeEmails)
        data["alternativeEmails"].push(item.toJSON());
    }
    data["phoneNumber"] = this.phoneNumber ? this.phoneNumber.toJSON() : <any>undefined;
    if (Array.isArray(this.alternativePhoneNumbers)) {
      data["alternativePhoneNumbers"] = [];
      for (let item of this.alternativePhoneNumbers)
        data["alternativePhoneNumbers"].push(item.toJSON());
    }
    data["address"] = this.address ? this.address.toJSON() : <any>undefined;
    if (Array.isArray(this.alternativeAddresses)) {
      data["alternativeAddresses"] = [];
      for (let item of this.alternativeAddresses)
        data["alternativeAddresses"].push(item.toJSON());
    }
    data["taxId"] = this.taxId;
    data["headquarters"] = this.headquarters;
    data["foundingDate"] = this.foundingDate ? this.foundingDate.toISOString() : <any>undefined;
    data["shareEquity"] = this.shareEquity;
    if (Array.isArray(this.partners)) {
      data["partners"] = [];
      for (let item of this.partners)
        data["partners"].push(item.toJSON());
    }
    if (Array.isArray(this.activities)) {
      data["activities"] = [];
      for (let item of this.activities)
        data["activities"].push(item.toJSON());
    }
    if (Array.isArray(this.registrations)) {
      data["registrations"] = [];
      for (let item of this.registrations)
        data["registrations"].push(item.toJSON());
    }
    if (Array.isArray(this.situations)) {
      data["situations"] = [];
      for (let item of this.situations)
        data["situations"].push(item.toJSON());
    }
    data["updateAt"] = this.updateAt ? this.updateAt.toISOString() : <any>undefined;
    if (this.additionalProperties) {
      data["additionalProperties"] = {};
      for (let key in this.additionalProperties) {
        if (this.additionalProperties.hasOwnProperty(key))
          (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
      }
    }
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    data["note"] = this.note;
    return data;
  }
}

export interface ISearchOrganizationsOutput {
  id?: string | undefined;
  name?: string | undefined;
  alternateName?: string | undefined;
  legalName?: string | undefined;
  email?: IEmailSchema | undefined;
  alternativeEmails?: IEmailSchema[] | undefined;
  phoneNumber?: IPhoneNumberSchema | undefined;
  alternativePhoneNumbers?: IPhoneNumberSchema[] | undefined;
  address?: IAddressSchema | undefined;
  alternativeAddresses?: IAddressSchema[] | undefined;
  taxId?: string | undefined;
  headquarters?: boolean | undefined;
  foundingDate?: Date | undefined;
  shareEquity?: number | undefined;
  partners?: IOrganizationSchema_PartnerSchema[] | undefined;
  activities?: IOrganizationSchema_ActivitySchema[] | undefined;
  registrations?: IOrganizationSchema_RegistrationSchema[] | undefined;
  situations?: IOrganizationSchema_SituationSchema[] | undefined;
  updateAt?: Date | undefined;
  additionalProperties?: { [key: string]: any; } | undefined;
  attachments?: IAttachmentSchema[] | undefined;
  note?: string | undefined;
}

export class EmailSchema implements IEmailSchema {
  id?: string | undefined;
  contact?: string | undefined;
  description?: string | undefined;
  address?: string | undefined;
  default?: boolean | undefined;

  constructor(data?: IEmailSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.contact = _data["contact"];
      this.description = _data["description"];
      this.address = _data["address"];
      this.default = _data["default"];
    }
  }

  static fromJS(data: any): EmailSchema {
    data = typeof data === 'object' ? data : {};
    let result = new EmailSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["contact"] = this.contact;
    data["description"] = this.description;
    data["address"] = this.address;
    data["default"] = this.default;
    return data;
  }
}

export interface IEmailSchema {
  id?: string | undefined;
  contact?: string | undefined;
  description?: string | undefined;
  address?: string | undefined;
  default?: boolean | undefined;
}

export class PhoneNumberSchema implements IPhoneNumberSchema {
  id?: string | undefined;
  contact?: string | undefined;
  description?: string | undefined;
  number?: string | undefined;
  default?: boolean | undefined;

  constructor(data?: IPhoneNumberSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.contact = _data["contact"];
      this.description = _data["description"];
      this.number = _data["number"];
      this.default = _data["default"];
    }
  }

  static fromJS(data: any): PhoneNumberSchema {
    data = typeof data === 'object' ? data : {};
    let result = new PhoneNumberSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["contact"] = this.contact;
    data["description"] = this.description;
    data["number"] = this.number;
    data["default"] = this.default;
    return data;
  }
}

export interface IPhoneNumberSchema {
  id?: string | undefined;
  contact?: string | undefined;
  description?: string | undefined;
  number?: string | undefined;
  default?: boolean | undefined;
}

export class AddressSchema implements IAddressSchema {
  id?: string | undefined;
  description?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  address3?: string | undefined;
  district?: string | undefined;
  city?: string | undefined;
  cityCode?: string | undefined;
  province?: string | undefined;
  provinceCode?: string | undefined;
  postalCode?: string | undefined;
  country?: string | undefined;
  countryCode?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  note?: string | undefined;

  constructor(data?: IAddressSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.description = _data["description"];
      this.address1 = _data["address1"];
      this.address2 = _data["address2"];
      this.address3 = _data["address3"];
      this.district = _data["district"];
      this.city = _data["city"];
      this.cityCode = _data["cityCode"];
      this.province = _data["province"];
      this.provinceCode = _data["provinceCode"];
      this.postalCode = _data["postalCode"];
      this.country = _data["country"];
      this.countryCode = _data["countryCode"];
      this.latitude = _data["latitude"];
      this.longitude = _data["longitude"];
      this.note = _data["note"];
    }
  }

  static fromJS(data: any): AddressSchema {
    data = typeof data === 'object' ? data : {};
    let result = new AddressSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["description"] = this.description;
    data["address1"] = this.address1;
    data["address2"] = this.address2;
    data["address3"] = this.address3;
    data["district"] = this.district;
    data["city"] = this.city;
    data["cityCode"] = this.cityCode;
    data["province"] = this.province;
    data["provinceCode"] = this.provinceCode;
    data["postalCode"] = this.postalCode;
    data["country"] = this.country;
    data["countryCode"] = this.countryCode;
    data["latitude"] = this.latitude;
    data["longitude"] = this.longitude;
    data["note"] = this.note;
    return data;
  }
}

export interface IAddressSchema {
  id?: string | undefined;
  description?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  address3?: string | undefined;
  district?: string | undefined;
  city?: string | undefined;
  cityCode?: string | undefined;
  province?: string | undefined;
  provinceCode?: string | undefined;
  postalCode?: string | undefined;
  country?: string | undefined;
  countryCode?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  note?: string | undefined;
}

export class OrganizationSchema_PartnerSchema implements IOrganizationSchema_PartnerSchema {
  person?: PersonSchema | undefined;
  role?: string | undefined;
  since?: Date | undefined;

  constructor(data?: IOrganizationSchema_PartnerSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.person = data.person && !(<any>data.person).toJSON ? new PersonSchema(data.person) : <PersonSchema>this.person;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.person = _data["person"] ? PersonSchema.fromJS(_data["person"]) : <any>undefined;
      this.role = _data["role"];
      this.since = _data["since"] ? new Date(_data["since"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): OrganizationSchema_PartnerSchema {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationSchema_PartnerSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["person"] = this.person ? this.person.toJSON() : <any>undefined;
    data["role"] = this.role;
    data["since"] = this.since ? this.since.toISOString() : <any>undefined;
    return data;
  }
}

export interface IOrganizationSchema_PartnerSchema {
  person?: IPersonSchema | undefined;
  role?: string | undefined;
  since?: Date | undefined;
}

export class PersonSchema implements IPersonSchema {
  id?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  fullName?: string | undefined;
  documentType?: string | undefined;
  documentNumber?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  note?: string | undefined;

  constructor(data?: IPersonSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.fullName = _data["fullName"];
      this.documentType = _data["documentType"];
      this.documentNumber = _data["documentNumber"];
      this.email = _data["email"];
      this.phoneNumber = _data["phoneNumber"];
      this.note = _data["note"];
    }
  }

  static fromJS(data: any): PersonSchema {
    data = typeof data === 'object' ? data : {};
    let result = new PersonSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["fullName"] = this.fullName;
    data["documentType"] = this.documentType;
    data["documentNumber"] = this.documentNumber;
    data["email"] = this.email;
    data["phoneNumber"] = this.phoneNumber;
    data["note"] = this.note;
    return data;
  }
}

export interface IPersonSchema {
  id?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  fullName?: string | undefined;
  documentType?: string | undefined;
  documentNumber?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  note?: string | undefined;
}

export class OrganizationSchema_ActivitySchema implements IOrganizationSchema_ActivitySchema {
  id?: string | undefined;
  number?: string | undefined;
  name?: string | undefined;
  primary?: boolean;

  constructor(data?: IOrganizationSchema_ActivitySchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.number = _data["number"];
      this.name = _data["name"];
      this.primary = _data["primary"];
    }
  }

  static fromJS(data: any): OrganizationSchema_ActivitySchema {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationSchema_ActivitySchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["number"] = this.number;
    data["name"] = this.name;
    data["primary"] = this.primary;
    return data;
  }
}

export interface IOrganizationSchema_ActivitySchema {
  id?: string | undefined;
  number?: string | undefined;
  name?: string | undefined;
  primary?: boolean;
}

export class OrganizationSchema_RegistrationSchema implements IOrganizationSchema_RegistrationSchema {
  taxId?: string | undefined;
  province?: string | undefined;
  status?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;

  constructor(data?: IOrganizationSchema_RegistrationSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.taxId = _data["taxId"];
      this.province = _data["province"];
      this.status = _data["status"];
      this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
      this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): OrganizationSchema_RegistrationSchema {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationSchema_RegistrationSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["taxId"] = this.taxId;
    data["province"] = this.province;
    data["status"] = this.status;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
    data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
    return data;
  }
}

export interface IOrganizationSchema_RegistrationSchema {
  taxId?: string | undefined;
  province?: string | undefined;
  status?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export class OrganizationSchema_SituationSchema implements IOrganizationSchema_SituationSchema {
  id?: string | undefined;
  description?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;

  constructor(data?: IOrganizationSchema_SituationSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.description = _data["description"];
      this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
      this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): OrganizationSchema_SituationSchema {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationSchema_SituationSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["description"] = this.description;
    data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
    data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
    return data;
  }
}

export interface IOrganizationSchema_SituationSchema {
  id?: string | undefined;
  description?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
}

export class SearchPeopleRequest implements ISearchPeopleRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId?: string;
  /** Id da `action` a ser executada. */
  actionId?: string;
  /** Chave de idempotência, utilizada para controle de requisições, deve ser única por requisição,
   caso se repita, sempre será retornado os mesmos dados. */
  idempotencyKey?: string | undefined;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;
  /** Número do CNPJ. */
  taxId!: string;

  constructor(data?: ISearchPeopleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.userSchema = "{}";
      this.userModel = "{}";
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orgAppId = _data["orgAppId"];
      this.actionId = _data["actionId"];
      this.idempotencyKey = _data["idempotencyKey"];
      this.userSchema = _data["userSchema"] !== undefined ? _data["userSchema"] : "{}";
      this.userModel = _data["userModel"] !== undefined ? _data["userModel"] : "{}";
      this.taxId = _data["taxId"];
    }
  }

  static fromJS(data: any): SearchPeopleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchPeopleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orgAppId"] = this.orgAppId;
    data["actionId"] = this.actionId;
    data["idempotencyKey"] = this.idempotencyKey;
    data["userSchema"] = this.userSchema;
    data["userModel"] = this.userModel;
    data["taxId"] = this.taxId;
    return data;
  }
}

export interface ISearchPeopleRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId?: string;
  /** Id da `action` a ser executada. */
  actionId?: string;
  /** Chave de idempotência, utilizada para controle de requisições, deve ser única por requisição,
   caso se repita, sempre será retornado os mesmos dados. */
  idempotencyKey?: string | undefined;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;
  /** Número do CNPJ. */
  taxId: string;
}

export class CreatePaymentResponse implements ICreatePaymentResponse {
  result?: CreatePaymentOutput;
  pagination?: Pagination | undefined;

  constructor(data?: ICreatePaymentResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.result = data.result && !(<any>data.result).toJSON ? new CreatePaymentOutput(data.result) : <CreatePaymentOutput>this.result;
      this.pagination = data.pagination && !(<any>data.pagination).toJSON ? new Pagination(data.pagination) : <Pagination>this.pagination;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.result = _data["result"] ? CreatePaymentOutput.fromJS(_data["result"]) : <any>undefined;
      this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : <any>undefined;
    }
  }

  static fromJS(data: any): CreatePaymentResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePaymentResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["result"] = this.result ? this.result.toJSON() : <any>undefined;
    data["pagination"] = this.pagination ? this.pagination.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICreatePaymentResponse {
  result?: ICreatePaymentOutput;
  pagination?: IPagination | undefined;
}

export class CreatePaymentOutput implements ICreatePaymentOutput {
  id?: string | undefined;
  commonId?: string | undefined;
  method?: PaymentMethod;
  viewMode?: PaymentViewMode;
  amount?: number;
  currency?: string;
  issueDate?: Date;
  expirationDate?: Date;
  additionalProperties?: { [key: string]: any; } | undefined;
  attachments?: AttachmentSchema[] | undefined;

  constructor(data?: ICreatePaymentOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.attachments) {
        this.attachments = [];
        for (let i = 0; i < data.attachments.length; i++) {
          let item = data.attachments[i];
          this.attachments[i] = item && !(<any>item).toJSON ? new AttachmentSchema(item) : <AttachmentSchema>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.commonId = _data["commonId"];
      this.method = _data["method"];
      this.viewMode = _data["viewMode"];
      this.amount = _data["amount"];
      this.currency = _data["currency"];
      this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
      this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
      if (_data["additionalProperties"]) {
        this.additionalProperties = {} as any;
        for (let key in _data["additionalProperties"]) {
          if (_data["additionalProperties"].hasOwnProperty(key))
            (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
        }
      }
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments!.push(AttachmentSchema.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreatePaymentOutput {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePaymentOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["commonId"] = this.commonId;
    data["method"] = this.method;
    data["viewMode"] = this.viewMode;
    data["amount"] = this.amount;
    data["currency"] = this.currency;
    data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
    data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
    if (this.additionalProperties) {
      data["additionalProperties"] = {};
      for (let key in this.additionalProperties) {
        if (this.additionalProperties.hasOwnProperty(key))
          (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
      }
    }
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICreatePaymentOutput {
  id?: string | undefined;
  commonId?: string | undefined;
  method?: PaymentMethod;
  viewMode?: PaymentViewMode;
  amount?: number;
  currency?: string;
  issueDate?: Date;
  expirationDate?: Date;
  additionalProperties?: { [key: string]: any; } | undefined;
  attachments?: IAttachmentSchema[] | undefined;
}

export enum PaymentMethod {
  Cash = "Cash",
  Credit = "Credit",
  Debit = "Debit",
  Boleto = "Boleto",
  BoletoPix = "BoletoPix",
  Pix = "Pix",
  Link = "Link",
}

export enum PaymentViewMode {
  None = "None",
  Manual = "Manual",
  Attachments = "Attachments",
}

export class CreatePaymentRequest implements ICreatePaymentRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId!: string;
  /** Id da `action` a ser executada. */
  actionId!: string;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;
  /** Url de callback que será chamada (post) sempre que houver interação no pagamento.
   O `payload` enviado no callback sempre será a resposta desse endpoint. */
  callbackUrl?: string | undefined;
  /** Identificador comum e único entre sistemas. */
  commonId!: string;
  /** Valor do pagamento. */
  amount?: number;
  /** Identificação da moeda (ISO). */
  currency?: string;
  /** Data de vencimento. */
  expirationDate?: Date;
  /** Conjunto de dados com informações do pedido. */
  order!: OrderSchema;
  /** Conjunto de dados com informações do cliente. */
  customer!: PersonSchema;
  /** Conjunto de dados com informações do endereço de faturamento. */
  billingAddress!: AddressSchema;

  constructor(data?: ICreatePaymentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      this.order = data.order && !(<any>data.order).toJSON ? new OrderSchema(data.order) : <OrderSchema>this.order;
      this.customer = data.customer && !(<any>data.customer).toJSON ? new PersonSchema(data.customer) : <PersonSchema>this.customer;
      this.billingAddress = data.billingAddress && !(<any>data.billingAddress).toJSON ? new AddressSchema(data.billingAddress) : <AddressSchema>this.billingAddress;
    }
    if (!data) {
      this.userSchema = "{}";
      this.userModel = "{}";
      this.order = new OrderSchema();
      this.customer = new PersonSchema();
      this.billingAddress = new AddressSchema();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.orgAppId = _data["orgAppId"];
      this.actionId = _data["actionId"];
      this.userSchema = _data["userSchema"] !== undefined ? _data["userSchema"] : "{}";
      this.userModel = _data["userModel"] !== undefined ? _data["userModel"] : "{}";
      this.callbackUrl = _data["callbackUrl"];
      this.commonId = _data["commonId"];
      this.amount = _data["amount"];
      this.currency = _data["currency"];
      this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
      this.order = _data["order"] ? OrderSchema.fromJS(_data["order"]) : new OrderSchema();
      this.customer = _data["customer"] ? PersonSchema.fromJS(_data["customer"]) : new PersonSchema();
      this.billingAddress = _data["billingAddress"] ? AddressSchema.fromJS(_data["billingAddress"]) : new AddressSchema();
    }
  }

  static fromJS(data: any): CreatePaymentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePaymentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["orgAppId"] = this.orgAppId;
    data["actionId"] = this.actionId;
    data["userSchema"] = this.userSchema;
    data["userModel"] = this.userModel;
    data["callbackUrl"] = this.callbackUrl;
    data["commonId"] = this.commonId;
    data["amount"] = this.amount;
    data["currency"] = this.currency;
    data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
    data["order"] = this.order ? this.order.toJSON() : <any>undefined;
    data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
    data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICreatePaymentRequest {
  /** Id do aplicativo instalado na organização. */
  orgAppId: string;
  /** Id da `action` a ser executada. */
  actionId: string;
  /** Schema de dados do usuário. */
  userSchema?: string;
  /** Modelo de dados do usuário com base no `UserSchema`. */
  userModel?: string;
  /** Url de callback que será chamada (post) sempre que houver interação no pagamento.
   O `payload` enviado no callback sempre será a resposta desse endpoint. */
  callbackUrl?: string | undefined;
  /** Identificador comum e único entre sistemas. */
  commonId: string;
  /** Valor do pagamento. */
  amount?: number;
  /** Identificação da moeda (ISO). */
  currency?: string;
  /** Data de vencimento. */
  expirationDate?: Date;
  /** Conjunto de dados com informações do pedido. */
  order: IOrderSchema;
  /** Conjunto de dados com informações do cliente. */
  customer: IPersonSchema;
  /** Conjunto de dados com informações do endereço de faturamento. */
  billingAddress: IAddressSchema;
}

export class OrderSchema implements IOrderSchema {
  id?: string | undefined;
  number?: string;
  title?: string | undefined;
  amount?: number;
  additionalProperties?: { [key: string]: any; } | undefined;
  attachments?: AttachmentSchema[] | undefined;

  constructor(data?: IOrderSchema) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
      if (data.attachments) {
        this.attachments = [];
        for (let i = 0; i < data.attachments.length; i++) {
          let item = data.attachments[i];
          this.attachments[i] = item && !(<any>item).toJSON ? new AttachmentSchema(item) : <AttachmentSchema>item;
        }
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.number = _data["number"];
      this.title = _data["title"];
      this.amount = _data["amount"];
      if (_data["additionalProperties"]) {
        this.additionalProperties = {} as any;
        for (let key in _data["additionalProperties"]) {
          if (_data["additionalProperties"].hasOwnProperty(key))
            (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
        }
      }
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments!.push(AttachmentSchema.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OrderSchema {
    data = typeof data === 'object' ? data : {};
    let result = new OrderSchema();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["number"] = this.number;
    data["title"] = this.title;
    data["amount"] = this.amount;
    if (this.additionalProperties) {
      data["additionalProperties"] = {};
      for (let key in this.additionalProperties) {
        if (this.additionalProperties.hasOwnProperty(key))
          (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
      }
    }
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    return data;
  }
}

export interface IOrderSchema {
  id?: string | undefined;
  number?: string;
  title?: string | undefined;
  amount?: number;
  additionalProperties?: { [key: string]: any; } | undefined;
  attachments?: IAttachmentSchema[] | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
